import { toast } from "react-toastify";

// Restricts input to numbers and plus, max 13 chars toast error if invalid
export function formatPhoneNumber(input) {
  if (!input) return input;
  const formatted = input.replace(/[^0-9+]/g, '').slice(0, 13);
  if (formatted !== input) {
    toast.error("Invalid phone number format!. Only numbers and '+' allowed, max 13 characters.");
  }
  return formatted;
}

// Validates if contact contains only 0-9 or +, and length between 10-15
export function isValidContact(contact) {
  if (!contact) return false;
  return /^[0-9+]{10,15}$/.test(contact);
}
// Capitalizes The First Letter Of A String
export const capitalizeFirstLetter = (str) => {
  if (!str) return str;  // If The String Is Empty, Return It As Is
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// Converts A String To Uppercase
export const toUpperCase = (str) => {
  if (!str) return str;  // If The String Is Empty, Return It As Is
  return str.toUpperCase();
};

// Handles numeric input, allowing only digits and showing an error if invalid
export function handleNumericInput(e, setterFunction) {
  const value = e.target.value;

  if (!/^\d*$/.test(value)) {
    toast.error("Only numbers (0-9) are allowed!");
    return;
  }

  // Convert to integer or set to empty string if the input is empty
  setterFunction(value ? parseInt(value, 10) : "");
}

export function handleNumericFloatInput(e, setterFunction) {
  let value;
  if (e && e.target) {
    value = e.target.value;
  } else {
    value = e;
  }

  // Allow numbers with up to two decimal places
  if (!/^\d*\.?\d{0,2}$/.test(value)) {
    toast.error("Only numbers with up to 2 decimal places are allowed!");
    return;
  }

  // Prevent leading multiple zeros (except for decimals like 0.5)
  if (value.startsWith("0") && value.length > 1 && !value.startsWith("0.")) {
    value = value.replace(/^0+/, ""); // Remove leading zeros
  }

  // Set the value as a string to allow typing decimals
  setterFunction(value);
}


// To lowercase
export function toLowerCase(str) {
  if (!str) return str;  // If The String Is Empty, Return It As Is
  return str.toLowerCase();
}

// Get today's date in YYYY-MM-DD format
export const getTodayDate = () => {
  return new Date().toISOString().split('T')[0];
};

// Get current month in YYYY-MM format
export const getCurrentMonth = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
};

// max date
export const getMaxDate = () => {
  const maxDate = getTodayDate();
  return maxDate;
};


export function validatePhoneNumberInput(value, setterFunction) {
  if (
    (value === '' ||
      (/^\+?[0-9]*$/.test(value) &&
        value.indexOf('+') <= 0 &&
        value.split('+').length <= 2)) &&
    value.length <= 15
  ) {
    setterFunction(value);
  } else {
    toast.error("Only numbers are allowed, and '+' only as the first character. Maximum length is 15 characters!");
  }
}

// Limit string to a maximum number of characters
export function limitLength(str, maxLength) {
  if (!str) return str;
  if (str.length > maxLength) {
    toast.error(`Maximum length is ${maxLength} characters!`);
    return str.slice(0, maxLength);
  }
  return str;
}

// Limit product name to a maximum number of characters
export function limitNameLength(str, maxLength) {
  if (!str) return str;
  if (str.length > maxLength) {
    toast.error(`Product name cannot exceed ${maxLength} characters!`);
    return str.slice(0, maxLength);
  }
  return str;
}

// Enhanced custom filter function for React Select components
// Supports multi-term search - all search terms must be present in the option label
export const customSelectFilter = (option, inputValue) => {
  if (!inputValue) return true;
  const searchValue = inputValue.toLowerCase().trim();
  const label = (option.label || '').toLowerCase();

  // Process search terms: add spaces around numbers, split, filter, remove special chars
  const terms = searchValue
    .replace(/(\d+)/g, ' $1 ')
    .split(/\s+/)
    .filter(Boolean)
    .map(term => term.replace(/[^a-z0-9]/g, ''));

  // Process label: add spaces around numbers, remove special chars except spaces
  const combined = label
    .replace(/(\d+)/g, ' $1 ')
    .replace(/[^a-z0-9\s]/g, '');

  return terms.every(term => combined.includes(term));
};

// Converts snake_case to Title Case (e.g., "product_exchange" to "Product Exchange")
export const snakeToTitleCase = (str) => {
  if (!str) return str;
  return str
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

// check if each purchase item has a valid buying price and quantity
export const checkValidPurchaseItems = (purchaseItems) => {
  for (const item of purchaseItems) {
    if (item.buyingPrice <= 0 || item.qty <= 0) {
      toast.error(` Please check the quantity and price for ${item.name}.`);
      return false;
    }
  }
  return true;
};

// Format date to YYYY-MM-DD
export const formatDateToYYYYMMDD = (date) => {
  if (!date) return '';
  return new Date(date).toISOString().split('T')[0];
};

// Format currency with Ksh. and 2 decimal places
export const formatCurrency = (amount) => {
  return `Ksh.${(parseFloat(amount) || 0).toFixed(2)}`;
};
